 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTSUSA_ISBN9781588169167_EPUB_IMG_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_img_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_TIT_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_tit_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_COP_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_cop_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_C1_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_c1_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_TOC_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_toc_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_FORE_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_fore_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_PART01_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_part01_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH01_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch01_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH02_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch02_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH03_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch03_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_PART02_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_part02_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH04_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch04_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH05_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch05_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_PART03_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_part03_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH06_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch06_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH07_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch07_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH08_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch08_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_PART04_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_part04_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH09_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch09_r1'
 import TEXTSUSA_ISBN9781588169167_EPUB_CH10_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_ch10_r1'
 import LOVE_2 from '@/components/love_2'
 import TEXTSUSA_ISBN9781588169167_EPUB_PHOTO_R1 from '@/components/Text/Susa_ISBN9781588169167_epub_photo_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Susa_ISBN9781588169167_epub_toc_r1",
 			"name" : "Text/Susa_ISBN9781588169167_epub_toc_r1",
 			"component" : TEXTSUSA_ISBN9781588169167_EPUB_TOC_R1
 		},
 		{
 			"path" : "/Text/Susa_ISBN9781588169167_epub_fore_r1",
 			"name" : "Text/Susa_ISBN9781588169167_epub_fore_r1",
 			"component" : TEXTSUSA_ISBN9781588169167_EPUB_FORE_R1
 		},
 		{
 			"path" : "/Text/Susa_ISBN9781588169167_epub_part01_r1",
 			"name" : "Text/Susa_ISBN9781588169167_epub_part01_r1",
 			"component" : TEXTSUSA_ISBN9781588169167_EPUB_PART01_R1
 		},
 		{
 			"path" : "/Text/Susa_ISBN9781588169167_epub_ch01_r1",
 			"name" : "Text/Susa_ISBN9781588169167_epub_ch01_r1",
 			"component" : TEXTSUSA_ISBN9781588169167_EPUB_CH01_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js